import request from '@/utils/request'


// 查询用户黑名单列表
export function listUserBlack(query) {
  return request({
    url: '/user/user/black/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户黑名单分页
export function pageUserBlack(query) {
  return request({
    url: '/user/user/black/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户黑名单详细
export function getUserBlack(data) {
  return request({
    url: '/user/user/black/detail',
    method: 'get',
    params: data
  })
}

// 新增用户黑名单
export function addUserBlack(data) {
  return request({
    url: '/user/user/black/add',
    method: 'post',
    data: data
  })
}

// 修改用户黑名单
export function updateUserBlack(data) {
  return request({
    url: '/user/user/black/edit',
    method: 'post',
    data: data
  })
}

// 删除用户黑名单
export function delUserBlack(data) {
  return request({
    url: '/user/user/black/delete',
    method: 'post',
    data: data
  })
}
